import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";
import loadStatus from "../util/loadStatus";

export const getMilestones = createAsyncThunk(
  "milestones/getMilestones",
  async (id, { rejectWithValue, getState }) => {
    try {
      const state = getState().milestones;
      if (state.count.getMilestones <= 1) {
        const res = await axios.get("/project-milestones/" + id);
        return res.data;
      }
      return state.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }

      return rejectWithValue(error.message);
    }
  }
);

export const addMilestone = createAsyncThunk(
  "milestones/addMilestone",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-milestone", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }

      return rejectWithValue(error.message);
    }
  }
);

export const editMilestone = createAsyncThunk(
  "milestones/editMilestone",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }

      return rejectWithValue(error.message);
    }
  }
);

export const deleteMilestone = createAsyncThunk(
  "milestones/deleteMilestone",
  async ({ id, reqData }, { rejectWithValue }) => {
    try {
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }

      return rejectWithValue(error.message);
    }
  }
);

const milestonesSlice = createSlice({
  name: "milestones",
  initialState: {
    total: 0,
    data: [],
    selected: {},
    selectedTask: {},
    loading: false,
    error: null,
    count: { getMilestones: 0, getMilestone: 0 },
  },
  reducers: {
    setMilestones: (state, action) => {
      state.data = action.payload;
    },
    setSelectedMilestone: (state, action) => {
      state.selected = action.payload;
    },
    unsetMilestones: (state) => {
      state.data = [];
      state.selected = {};
    },
    setSelectedMileTask: (state, action) => {
      state.selectedTask = action.payload;
    },
    unsetSelectedMileTask: (state) => {
      state.selectedTask = {};
    },
    toggleMilestone: (state, action) => {
      const milestone = state.data.find((m) => m.id === action.payload);
      if (milestone) {
        milestone.isOpen = !milestone.isOpen;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      //Get all Milestones
      .addCase(getMilestones.pending, (state) => {
        state.loading = loadStatus.loading;
        state.error = null;
        state.count.getMilestones = ++state.count.getMilestones;
      })
      .addCase(getMilestones.fulfilled, (state, action) => {
        state.loading = loadStatus.success;
        state.data = action.payload;
        state.count.getMilestones = 0;
      })
      .addCase(getMilestones.rejected, (state, action) => {
        state.loading = loadStatus.error;
        state.error = action.payload;
        state.count.getMilestones = 0;
      })
      //Add milestone
      .addCase(addMilestone.pending, (state) => {
        state.loading = loadStatus.loading;
        state.error = null;
      })
      .addCase(addMilestone.fulfilled, (state, action) => {
        state.loading = loadStatus.success;
        state.data.unshift(action.payload);
      })
      .addCase(addMilestone.rejected, (state, action) => {
        state.loading = loadStatus.error;
        state.error = action.payload;
      })
      //Update milestone
      .addCase(editMilestone.pending, (state) => {
        state.loading = loadStatus.loading;
        state.error = null;
      })
      .addCase(editMilestone.fulfilled, (state, action) => {
        state.loading = loadStatus.success;
        const index = state.data.findIndex(
          (item) => (item.id = action.payload.id)
        );
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editMilestone.rejected, (state, action) => {
        state.loading = loadStatus.error;
        state.error = action.payload;
      })
      //Delete milestone
      .addCase(deleteMilestone.pending, (state) => {
        state.loading = loadStatus.loading;
        state.error = null;
      })
      .addCase(deleteMilestone.fulfilled, (state, action) => {
        state.loading = loadStatus.success;
        state.data.filter((item) => item.id !== action.meta.arg.id);
      })
      .addCase(deleteMilestone.rejected, (state, action) => {
        state.loading = loadStatus.error;
        state.error = action.payload;
      });
  },
});

export const {
  setMilestones,
  setSelectedMilestone,
  unsetMilestones,
  toggleMilestone,
  setSelectedMileTask,
  unsetSelectedMileTask,
} = milestonesSlice.actions;
export default milestonesSlice.reducer;
